import { useNavigate } from 'react-router-dom';
import Checkbox from '../../components/checkbox/checkbox';
import styles from './fundingStep.module.css';
import ExternalLink from '../../components/externalLink/externalLink';

export default function FundingStep ({ formData, setFormData }) {
  const navigate = useNavigate();

  const validate = (currentOptions) => {
    let isValid = false;
    currentOptions.forEach((option) => {
      if (option.isChecked) {
        isValid = true;
      }
    });
    return isValid;
  };

  const handleChange = (checkboxOptions) => {
    // Update form
    setFormData((prevData) => ({
      ...prevData,
      fundingStep: {
        fundingSource: checkboxOptions,
        isValid: validate(checkboxOptions)
      }
    }));

    // Update url params
    const searchParams = new URLSearchParams(window.location.search);
    const checkedBoxes = checkboxOptions.filter(
      (checkbox) => checkbox.isChecked === true
    );
    const newParam = checkedBoxes.map((box) => box.value);

    if (newParam.length > 0) {
      searchParams.set('f', newParam);
    } else {
      searchParams.delete('f');
    }
    navigate(`?${searchParams.toString()}`, { replace: true });
  };

  const providerType = formData.providerStep?.provider;

  return (
    <div className={styles.pageContainer}>
      <h2 className={styles.mobileH2}>
        {providerType === 'registered' && 'How are you funded?'}
        {providerType === 'prospective' && 'How are you funded?'}
        {providerType === 'other' && 'What funding does this relate to?'}
      </h2>
      <p className={styles.description}>
        Understanding your funding source/s can change the requirements that apply to you.
      </p>
      <ExternalLink href='https://www.health.gov.au/our-work/new-model-for-regulating-aged-care/how-it-works/deeming'>I'm not sure</ExternalLink>
      <p className={styles.selectText}>Select all that apply</p>
      <Checkbox
        hasSelectAll={false}
        options={formData.fundingStep.fundingSource}
        handleChange={handleChange}
      />
    </div>
  );
}
